"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServiceSubTypeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useServiceSubTypeStore = (0, pinia_1.defineStore)("serviceSubTypeStore", {
    state: () => ({
        serviceSubTypes: [],
    }),
    getters: {
        getAll(state) {
            return state.serviceSubTypes;
        },
    },
    actions: {
        async fetchServiceSubTypes() {
            this.serviceSubTypes = [];
            try {
                const response = await (0, fetch_1.default)("/api/service-sub-types/get", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
                if (response.error) {
                    throw new Error(i18n_1.default.trans("backend_service_sub_type_error", "No service sub type found!", "backend_service_sub_types"));
                }
                response.forEach((item) => {
                    //console.log(item);
                    this.serviceSubTypes.push(item);
                });
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
});
